module.exports = "<div *ngIf=\"visible\" class=\"dialog\">\r\n  <ng-content></ng-content>\r\n</div>\r\n<div *ngIf=\"visible\" class=\"overlay\"></div>"